export default "__VITE_ASSET__991211df__"